import { useSelector } from 'react-redux'
import { selectCurrentUser } from '@user/store/authorization/userSlice'
import { useMemo } from 'react'
import { externalProductPestPacName } from '@sales-center/common'

export const useGetExternalAppName = (): string => {
  const { externalProduct } = useSelector(selectCurrentUser)

  return useMemo(() => {
    switch (externalProduct) {
      case externalProductPestPacName:
        return 'PestPac'
      default:
        return ''
    }
  }, [externalProduct])
}
